import { USER_LOADED_CLIENT, AUTH_ERROR_CLIENT, LOGIN_SUCCESS_CLIENT, LOGIN_FAIL_CLIENT, LOGOUT_CLIENT } from '../actions/types';

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: false,
  loading: true,
  error: null
}
export default function(state = initialState, action){
  const { type, payload } = action;

  switch(type){
    case USER_LOADED_CLIENT:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
      }
    case LOGIN_SUCCESS_CLIENT:
      localStorage.setItem('token', payload.token);
      return {
        ...state,
        token: payload.token,
        isAuthenticated: true,
        loading: false,
        error: null
      }
    case AUTH_ERROR_CLIENT:
    case LOGOUT_CLIENT:
      localStorage.removeItem('token');
      return {
        token: null,
        isAuthenticated: false,
        loading: false,
        error: null
      }
    case LOGIN_FAIL_CLIENT:
      return {
        ...state,
        error: payload
      }
    default:
      return state;
  }
}